import classNames from 'classnames';
import React from 'react';

export interface SidebarMenuProps {
  className?: string;
  children?: React.ReactNode;
}

export const SidebarMenu = ({ children, className }: SidebarMenuProps) => (
  <ul className={classNames('flex flex-col ds-legacy__ul p-0 gap-4', className)}>{children}</ul>
);
